module.exports = __webpack_public_path__ + "static/media/runondevice.b4861509.svg";